import React, { useState } from 'react';
import '../../styles/MenuGrid.css';
import FoodDetailModal from './FoodDetailModal';

function MenuGrid({ items }) {
  const [selectedItem, setSelectedItem] = useState(null);

  const handleCardClick = (item) => setSelectedItem(item);

  if (items.length === 0) {
    return <p>No menu items match your filters.</p>;
  }

  return (
    <>
      <div className="menu-grid">
        {items.map((item, index) => (
          <div
            key={`${item.name}-${index}`}
            onClick={() => handleCardClick(item)}
            onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleCardClick(item)}
            role="button"
            tabIndex={0}
            className="menu-grid-item"
          >
            <div className="card-header">
              <h4 className="card-title">{item.name}</h4>
            </div>
            <div className="card-footer">
              <span className="card-time">{item.timePeriods.join(', ')}</span>
            </div>
          </div>
        ))}
      </div>

      <FoodDetailModal food={selectedItem} onClose={() => setSelectedItem(null)} />
    </>
  );
}

export default MenuGrid;